(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const drawer = document.getElementById('menu-drawer');

  document.querySelectorAll('[data-drawer-open]').forEach((button) => {
    button.addEventListener('click', () => drawer.showModal());
  });

  function closeDrawer() {
    if (drawer.classList.contains('is-closing')) return;

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      drawer.classList.remove('is-closing');
      drawer.close();
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }

    drawer.classList.add('is-closing');
    drawer.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 300);
  }

  document.querySelectorAll('[data-drawer-close]').forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  drawer.addEventListener('click', (event) => {
    if (!event.target.closest('.drawer__panel')) closeDrawer();
  });

  drawer.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDrawer();
  });

  // Close the mega-menu when clicking elsewhere.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.header__mega[open]').forEach((mega) => {
      if (!mega.contains(event.target)) mega.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Thumbnail gallery swap
  const mainImage = document.getElementById('main-product-image');
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.full;
      mainImage.removeAttribute('srcset');
      document
        .querySelectorAll('[data-thumb]')
        .forEach((t) => t.classList.toggle('product__thumb--active', t === thumb));
    });
  });

  // Quantity stepper
  const qtyInput = document.querySelector('.qty__input');
  document.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
  });
  document.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
  });

  // Variant selection updates both displayed prices
  document.querySelectorAll('.product__variant-box input').forEach((input) => {
    input.addEventListener('change', () => {
      const price = input.dataset.variantPrice;
      if (!price) return;
      const priceEl = document.querySelector('[data-product-price]');
      const addPrice = document.querySelector('[data-add-price]');
      if (priceEl) priceEl.textContent = price;
      if (addPrice) addPrice.textContent = price;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
